jQuery(document).ready(function () {
  const contentEl = document.querySelector('.js-track-recently-viewed')
  const { handle, template } = contentEl.dataset;

  var JunoTrackRecentlyViewed = (function (module, $) {
    'use strict';

    if (handle && template) {
      // Public functions
      var init;

      // Private general variables
      var numberOfItemsToTrack, thisProductHandle, allRecentProducts = [];

      init = function () {
        numberOfItemsToTrack = 10;
        thisProductHandle = handle;

        for (var i = 0; i < numberOfItemsToTrack; i++) {
          if (localStorage.getItem('recentlyViewed-' + i)) {
            allRecentProducts.push(localStorage.getItem('recentlyViewed-' + i));
          }
        }

        if (allRecentProducts.indexOf(thisProductHandle) == -1) {
          allRecentProducts.push(thisProductHandle);
          if (allRecentProducts.length > numberOfItemsToTrack) {
            allRecentProducts.shift();
          }

          for (var i = 0; i < allRecentProducts.length; i++) {
            localStorage.setItem('recentlyViewed-' + i, allRecentProducts[i]);
          }
        }
      };

      module = {
        init: init
      };

      return module;
    }
  }(JunoTrackRecentlyViewed || {}, jQuery));

  if (template && template.includes('product')) {
    JunoTrackRecentlyViewed.init();
  }
});
